import { faBars, faClose } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { useIsPanelOpen, useTogglePanel } from 'stores/usePanelsStateStore'
import { cn } from 'utils/cn'

export const MobileMenuButton = () => {
  const triggerEvent = useTriggerEvent()

  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')

  const togglePanel = useTogglePanel()

  const handleMenuClick = () => {
    togglePanel('conversations_menu')

    triggerEvent({
      name: isConversationMenuPanelOpen
        ? 'kai_sidepanel_closed'
        : 'kai_sidepanel_opened',
    })
  }

  return (
    <div className="flex h-full max-w-[80px] items-center justify-between">
      <div className="flex w-full justify-center">
        <button
          type="button"
          className={cn('flex ', {
            'transition delay-150': !isConversationMenuPanelOpen,
          })}
          onClick={handleMenuClick}
        >
          <FontAwesomeIcon
            icon={!isConversationMenuPanelOpen ? faBars : faClose}
            className="size-6"
          />
        </button>
      </div>
    </div>
  )
}
